// Angular
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HasSyscodesGuard } from 'app_sasha/shared/guards/has-syscodes.guard';
import { ProcessingQualityCheckComponent } from "app_sasha/pages/processing-quality-check/processing-quality-check.component";
import { BookingQualityCheckResolver } from "app_sasha/pages/processing-quality-check/processing-quality-check.resolver";

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: 'list',
                component: ProcessingQualityCheckComponent,
                canActivate: [HasSyscodesGuard],
                resolve: {
                    bookings: BookingQualityCheckResolver,
                },
                data: { permissionPath: 'sasha.processing.qualityCheck.use', redirectTo: '/sasha/home' },
            },
        ]),
    ],
    exports: [
        RouterModule,
    ]
})
export class BookingQualityCheckRouting { }